import React from "react";
import GridItem from "../gridItem";
import Swal from "sweetalert2";
import * as C from "./style";

const Grid = ({ itens, setItens }) => {
    const onDelete = (ID) => {
            Swal.fire({
                title: 'Deseja remover?',
                text: "Essa ação não pode ser desfeita!",
                type: 'warning',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'teal',
                cancelButtonColor: 'grey',
                confirmButtonText: 'Remover',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    const newArray = itens.filter((transaction) => transaction.id !== ID);
                    setItens(newArray);
                    localStorage.setItem("transactions", JSON.stringify(newArray));
                }
            });

    };

    return (
        <C.Table id="main-table">
        <C.Thead>
            <C.Tr>
            <C.Th width={40}>Descrição</C.Th>
            <C.Th width={40} alignCenter >Valor</C.Th >
            <C.Th width={10} alignCenter>
                Tipo
            </C.Th>
            <C.Th width={10}></C.Th>
            </C.Tr>
        </C.Thead>
        <C.Tbody>
            {itens?.map((item, index) => (
            <GridItem key={index} item={item} onDelete={onDelete} />
            ))}
        </C.Tbody>
        </C.Table>
    );
};

export default Grid;